// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { parseISO } from "date-fns";
import PropTypes from "prop-types";

import { Pill, Avatar, Link } from "components/elements";
import {
  TableRow,
  TableRowColumn,
  TableRowColumnOverflow,
} from "components/layout";
import { trans } from "src/translations";
import { formatDateTime } from "utils/date";

import styles from "../_shared/UsersTable.scss";
import { getFullName, getOrganizationNamesString } from "../_utils";
import { UserActionMenu } from "./UserActionMenu";

const overflowText = (user) => {
  return (
    <>
      {getFullName(user)}
      {!user.is_active && (
        <Pill text={trans.USER_LIST__DEACTIVATED()} icon="users" />
      )}
    </>
  );
};

export const UserRow = ({ setActive, user }) => {
  const { id, avatar, organizationNames, is_active } = user;
  const actionPath = `/users/admin/${id}/edit`;

  return (
    <TableRow>
      <TableRowColumn>
        <Avatar size="24px" src={avatar} />
      </TableRowColumn>
      <TableRowColumnOverflow overflowText={overflowText(user)}>
        <Link to={actionPath} className={styles.userName}>
          {getFullName(user)}
        </Link>
        {!is_active && (
          <Pill text={trans.USER_LIST__DEACTIVATED()} icon="users" />
        )}
      </TableRowColumnOverflow>
      <TableRowColumnOverflow columnClass={styles.organizationsColumn}>
        {getOrganizationNamesString(organizationNames)}
      </TableRowColumnOverflow>
      <TableRowColumn>
        {user.last_login
          ? formatDateTime(parseISO(String(user.last_login)))
          : "-"}
      </TableRowColumn>
      <TableRowColumn>
        <UserActionMenu user={user} setActive={setActive} />
      </TableRowColumn>
    </TableRow>
  );
};

UserRow.propTypes = {
  setActive: PropTypes.func.isRequired,
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    avatar: PropTypes.string,
    given_name: PropTypes.string,
    family_name: PropTypes.string,
    is_active: PropTypes.bool,
    last_login: PropTypes.string,
    organizationNames: PropTypes.array.isRequired,
  }).isRequired,
};
